// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"ben_a bhk_tp","StrollerBoxWidget__imageCounselling":"ben_b bhk_ke"};